<template>
  <v-row justify="center">
    <v-dialog :value="abertoLocal" fullscreen hide-overlay transition="dialog-bottom-transition" @input="atualizarDialogo">
      <v-card>
        <!-- Barra superior -->
        <v-toolbar dark color="primary" class="px-5">
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="fecharDialogo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Conteúdo principal -->
        <v-card-text class="px-8 py-4">
          <slot />
        </v-card-text>

        <!-- Rodapé opcional -->
        <v-divider v-if="$slots.rodape" class="my-2"></v-divider>
        <v-card-actions v-if="$slots.rodape" class="px-6 py-3">
          <slot name="rodape" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'DialogoBase',

    props: {
      value: {
        type: Boolean,
        default: false
      },
      titulo: {
        type: String,
        default: ''
      }
    },

    computed: {
      abertoLocal() {
        return this.value;
      }
    },

    methods: {
      atualizarDialogo(valor) {
        this.$emit('input', valor);
      },
      fecharDialogo() {
        this.$emit('input', false);
        this.$emit('fechar');
      }
    }
  };
</script>

<style scoped>
  .v-toolbar-title {
    font-weight: 600;
    font-size: 1.1rem;
  }

  .margem {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }
</style>
